export type PosToConsiderKey = PosKey
export interface RelativeCoords {
  top: number
  bottom: number
  left: number
  right: number
}

export interface MarkerPosDetails {
  pos: number
  relativeCoords: RelativeCoords
  markerCoords: {
    top: number
    bottom: number
    left: number
    right: number
  }
}
export interface FillableElementPosition {
  editorInstanceId: string
  markerPos?: {
    posFromLeftTop: MarkerPosDetails
    posFromLeftBottom?: MarkerPosDetails
    posFromCenterTop?: MarkerPosDetails
    posFromCenterBottom?: MarkerPosDetails
    posFromCenterCenter?: MarkerPosDetails
    posFromRightTop?: MarkerPosDetails
    posFromRightBottom?: MarkerPosDetails
    posFromNodeDom?: MarkerPosDetails
  }
  elementRect: DOMRect
  posToConsiderKey: PosToConsiderKey
  quadrant: number | null
  parentElementRect: DOMRect | null
  isAllPositionsSame: boolean
}

export enum PosKey {
  posFromLeftTop = 'posFromLeftTop',
  posFromLeftBottom = 'posFromLeftBottom',
  posFromCenterTop = 'posFromCenterTop',
  posFromCenterBottom = 'posFromCenterBottom',
  posFromCenterCenter = 'posFromCenterCenter',
  posFromRightTop = 'posFromRightTop',
  posFromRightBottom = 'posFromRightBottom',
  posFromNodeDom = 'posFromNodeDom',
}
